import classnames from 'classnames';
import React__default from 'react';
import Input from '../../../Input/index.js';
import { MULTIPLE_ROW_SELECT, SINGLE_ROW_SELECT } from '../utils/constants.js';
import { useTable } from '../utils/hooks.js';
import { getSelectAllStatus, getAllSelectedRows } from './utils.js';

var SelectionCellAll = function SelectionCellAll(_ref) {
  var pinned = _ref.pinned;
  var _useTable = useTable(),
    _useTable$state = _useTable.state,
    name = _useTable$state.name,
    columns = _useTable$state.columns,
    dataTestId = _useTable$state.dataTestId,
    displayData = _useTable$state.displayData,
    isClient = _useTable$state.isClient,
    groupChildRowsOnPage = _useTable$state.groupChildRowsOnPage,
    onRowSelect = _useTable$state.onRowSelect,
    pagination = _useTable$state.pagination,
    rowSelection = _useTable$state.rowSelection,
    selectedRows = _useTable$state.selectedRows;
  if (!displayData || displayData.length <= 0) {
    return null;
  }
  var itemRange = pagination.itemRange;
  var selectAllEnabled = rowSelection === MULTIPLE_ROW_SELECT;
  var selectionEnabled = rowSelection === SINGLE_ROW_SELECT || selectAllEnabled;
  var selectableRows = isClient ? columns !== null && columns !== void 0 && columns.hasRowGroup ? groupChildRowsOnPage : displayData.slice(itemRange.start - 1, itemRange.end) : displayData;
  var _getSelectAllStatus = getSelectAllStatus(selectedRows, selectableRows),
    isSelectAllChecked = _getSelectAllStatus.isSelectAllChecked,
    isIntermediate = _getSelectAllStatus.isIntermediate;
  var onCheckboxChange = function onCheckboxChange(checked) {
    var selections = getAllSelectedRows({
      checked: checked,
      selectableRows: selectableRows,
      selectedRows: selectedRows
    });
    onRowSelect && onRowSelect(selections);
  };
  var columnClasses = classnames('C-TableAdvanced__headerCell', 'selectAllCell', {
    '--pinned': pinned
  });
  return selectionEnabled && /*#__PURE__*/React__default.createElement("th", {
    style: {
      left: 0
    },
    className: columnClasses,
    scope: "col",
    role: "columnheader",
    "data-testid": dataTestId ? "".concat(dataTestId, "-selection-cell-all") : null
  }, selectAllEnabled && /*#__PURE__*/React__default.createElement(Input.Checkbox, {
    checked: isSelectAllChecked,
    "data-testid": dataTestId ? "".concat(dataTestId, "-selection-cell-all-checkbox") : null,
    id: "".concat(name, "-select-all-rows"),
    "aria-label": "".concat(isSelectAllChecked ? 'Deselect' : 'Select', " all rows"),
    indeterminate: isIntermediate,
    onChange: function onChange(event) {
      onCheckboxChange(event.target.checked);
    }
  }));
};

export { SelectionCellAll as default };
